import { BotaoComTexto } from '@digix-ui/componentes'

import { Dialogo } from '@/components/ui/Dialogo'

import type { DialogoDeCancelamentoProps } from './types'

export function DialogoDeCancelamento({
  deveSerExibido,
  titulo,
  descricao,
  aoConfirmar,
  aoFechar,
}: DialogoDeCancelamentoProps): JSX.Element {
  return (
    <Dialogo.Root
      tamanho="pequeno"
      deveSerExibido={deveSerExibido}
      aoFechar={aoFechar}
    >
      <Dialogo.Header>
        <Dialogo.Title>{titulo}</Dialogo.Title>
      </Dialogo.Header>

      <Dialogo.Body>
        <p>{descricao}</p>
      </Dialogo.Body>

      <Dialogo.Footer>
        <BotaoComTexto tipo="button" cor="primaria" onClick={aoConfirmar}>
          Sim, cancelar
        </BotaoComTexto>
        <BotaoComTexto
          tipo="button"
          cor="cinza"
          visual="contorno"
          onClick={aoFechar}
        >
          Continuar baixando
        </BotaoComTexto>
      </Dialogo.Footer>

      <Dialogo.CloseButton onClick={aoFechar} />
    </Dialogo.Root>
  )
}
